import React from 'react';
import AdminMenu from '../../../components/AdminMenu/AdminMenu';
import AttachementField from '../../../components/AttachementField/AttachementField';
import '../../../resources/adminStyle.scss';
import {admissionService} from '../../../services/AdmissionService';
import NotificationSystem from 'react-notification-system';
import DeletePUGCertificates from '../../../components/DeleteDialog/DeleteDialog';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import AuthenticationService from '../../../services/AuthenticationService';
import DocumentOpenManager from '../../../managers/DocumentOpenManager';

const documentOpenManager = new DocumentOpenManager();

class AdminAdmission extends React.Component{
    constructor(props){
        super(props)
        this.state={
           newAdmission:{
            title:'',
            date:'',
            description:'',
            document:''
           },
           existingAdmissions:[],
           deleteAdmission: {
            openedDialog: false,
            deleteId: 0
          },
          pagination: {}
        }
        this.authentication = new AuthenticationService();
    }
    handleChange=event=>{
        let newAdmission = { ...this.state.newAdmission };
        newAdmission[event.target.name] = event.target.value;
  
          this.setState({ newAdmission });
      }

      componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        admissionService
        .getAll()
        .then(response => {
          this.setAdmissionState(response);
        })
        .catch(error => {
          console.log(error);
        });
      }
      setAdmissionState = response => {
        let existingAdmissions = this.state.existingAdmissions;
        existingAdmissions = response.admissions;
        this.setState({
            existingAdmissions
        });
        let pagination = { ...this.state.pagination };
        pagination = response.pagination;
        this.setState({
          pagination
        });
      };
      handlePageClick = currentPage => {
        admissionService
          .getAll(currentPage.selected + 1)
          .then(response => {
            this.setAdmissionState(response);
          })
          .catch(error => console.log(error));
      };
      resetForm = () => {
        let newAdmission = { ...this.state.newAdmission };
        newAdmission = {
          title: '',
          date:'',
          description:'',
          document: ''
        };
        this.setState({ newAdmission });
        this.setState({ disabledDocument: false });
      };
      openDeleteDialog = id => {
        let deleteAdmission = { ...this.state.deleteAdmission };
        deleteAdmission = {
          openedDialog: true,
          deleteId: id
        };
    
        this.setState({ deleteAdmission });
      };
    
      closeDeleteDialog = () => {
        let deleteAdmission = { ...this.state.deleteAdmission };
        deleteAdmission = {
          openedDialog: false,
          deleteId: 0
        };
    
        this.setState({ deleteAdmission });
      };
      handleFormSubmit = event => {
        event.preventDefault();
    
        admissionService
          .createOrUpdate(this.state.newAdmission)
          .then(response => {
    
            let existingAdmissions = this.state.existingAdmissions;
    
            let index = existingAdmissions.findIndex(
              existingAdmissions => existingAdmissions.id === response.id
            );
    
            if (index !== -1) {
              existingAdmissions[index] = response;
            } else {
              existingAdmissions.push(response);
            }
    
            this.setState({
              existingAdmissions
            });
    
            this._notificationSystem.addNotification({
              message: `Informarea a fost ${
                this.state.newAdmission.id ? 'editata' : 'adaugata'
              } cu success.`,
              level: 'success',
              position: 'tc'
            });

            this.resetForm();
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problemă la adăugare, faceti refresh la pagina sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
      onDropDocument = documents => {
        let newAdmission = { ...this.state.newAdmission };
        let reader = new FileReader();
        let self = this;
    
        reader.onload = function(upload) {
          newAdmission.document = documents[0];
    
          self.setState({ newAdmission });
          self.setState({ disabledDocument: true });
        };
        reader.readAsDataURL(documents[0]);
      };
    
      removeDocument = () => {
        let newAdmission = { ...this.state.newAdmission };
        newAdmission.document = null;
    
        this.setState({ newAdmission });
        this.setState({ disabledDocument: false });
      };
    
      setAdmissionForEdit = (event, admission) => {
          event.preventDefault();

        let newAdmission = { ...this.state.newAdmission };
        newAdmission = Object.assign({}, admission);
        this.setState({ newAdmission });
    
        if (newAdmission.document && newAdmission.document.url) {
          this.setState({ disabledDocument: true });
        }
      };
    
      handleDelete = () => {
        admissionService
          .deleteAdmission(this.state.deleteAdmission.deleteId)
          .then(() => {
            let existingAdmissions = this.state.existingAdmissions.slice();
            existingAdmissions = existingAdmissions.filter(
                admission => admission.id !== this.state.deleteAdmission.deleteId
            );
            this.setState({ existingAdmissions });
    
            this.closeDeleteDialog();
    
            this._notificationSystem.addNotification({
              message: 'Informarea a fost ștearsa cu success.',
              level: 'success',
              position: 'tc'
            });
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problema la ștergere, faceți refresh la pagină sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
    render(){
        return(
            <div className='admin'>
                <AdminMenu/>
                <div className='admin__wrapper'>
                    <h2 className='admin__title'>Admitere</h2>
                    <h3 className='admin__subtitle'>Adaugă o informatie referitoare la admitere:</h3>
                        <form className='admin__form' onSubmit={this.handleFormSubmit}>
                            <h4 className='admin__label'>Titlu:</h4>
                            <input
                                className="admin__field"
                                type="text"
                                name="title"
                                onChange={this.handleChange}
                                required
                                value={this.state.newAdmission.title}/>
                            <h4 className='admin__label'>Dată:</h4>
                            <input
                                className="admin__field"
                                type="date"
                                name="date"
                                required
                                onChange={this.handleChange}
                                value={this.state.newAdmission.date}/>
                             <h4 className='admin__label'>Detaliere (optional):</h4>
                            <textarea
                                rows='5'
                                cols='10'
                                className="admin__field admin__textarea"
                                type="text"
                                name="description"
                                onChange={this.handleChange}
                                value={this.state.newAdmission.description}/>
                            <div className='admin__attachement'>
                                <AttachementField
                                onDrop={this.onDropDocument}
                                removeDocument={this.removeDocument}
                                document={this.state.newAdmission.document}
                                documentFilename={
                                    this.state.newAdmission.document_filename
                                }
                                />
                            </div>
                            <button type='submit' className='admin__submit-button'> {this.state.newAdmission.id
                        ? 'Editează'
                        : 'Adaugă'} informare</button>       
                        </form>
                        <div className='admin__existing-documents'>
                        {this.state.existingAdmissions && this.state.existingAdmissions.length?  <h3 className='admin__no-documents'> Documente existente:</h3> : ''} 
                        {this.state.existingAdmissions && this.state.existingAdmissions.length? 
                        <div className='admin__existing-docs-wrapper'>
                         {this.state.existingAdmissions.map(admission=>
                            ( <div className='admin__card'>
                                 <h3 className='admin__card-title'>{admission.title}</h3>
                                 <div className='admin__date-box'>
                                    <img src='/images/icons/calendar.png' alt='calendar'/>
                                    <h4 className='admin__card-date'>{admission.date}</h4>
                                 </div>
                                 <p className='admin__card-description'>{admission.description}</p>
                                 <div className='admin__document-box'  onClick={() =>
                                    documentOpenManager.open(admission.document)
                                    }>
                                     <img src='/images/icons/file.png' alt='file'/>
                                     <h3 className='admin__document-name'>Vezi document</h3>
                                 </div>
                                 <div className='admin__actions'>
                                    <h4 className='admin__edit' onClick={event => this.setAdmissionForEdit(event, admission)} >Editează</h4>
                                    <h4 className='admin__delete'  onClick={() => this.openDeleteDialog(admission.id)}>Șterge</h4>
                                 </div>
                             </div>)
                         )}
                         </div>: 
                        <h3 className='admin__no-documents'> Nu sunt documente adăugate.</h3>
                    }
                       
                               
                        </div>
                </div>
                <NotificationSystem
                    ref="notificationSystem"
                    style={NotificationSystemStyle}
                    />
                 <DeletePUGCertificates
                    opened={this.state.deleteAdmission.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteți sigur că doriti să ștergeti aceasta informare?"
                    aditionalText="Dupa ștergere, informarea nu va mai putea fi recuperata."
                  />
            </div>
        )
    }
}
export default AdminAdmission;